// LogoIcon.tsx
import React from 'react'

interface LogoIconProps {
  width?: number | string
  height?: number | string
}

const LogoIcon: React.FC<LogoIconProps> = ({ width = 32, height = 34 }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 32 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M32 0L27.2651 34L16.5635 25.7581L24.8976 7.68342L10.6929 21.2225L0 12.9637L32 0Z'
      fill='#3ED865'
    />
  </svg>
)

export default LogoIcon
